export default function useFormatNumber() {
  /**
   * @param value : string
   * @returns :string (천의자리 숫자마다 ",")
   */
  const formatAddCommas = (value: string): string => {
    if (!value) return '';
    const numberValue = value.replaceAll(',', ''); // 콤마 제거
    return numberValue.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 3자리마다 쉼표 추가
  };

  /**
   * @param value : string (,있는 숫자 텍스트)
   * @returns :number ( "," 제거하고 toNumber )
   */
  const formatRemoveCommas = (value: string): number => {
    if (!value || value === '') return 0;
    return parseInt(value.replaceAll(',', ''));
  };

  return {
    formatAddCommas,
    formatRemoveCommas,
  };
}
